import {
  parseSearchNumberValue,
  parseSearchStringValue,
} from 'infrastructure/functions/parse-query-string';
import { useQueryFilterNew } from 'infrastructure/hooks/common/use-query-param-new';

import type { TParseFunctions } from 'infrastructure/hooks/common/use-query-param-new';
import type {
  PapAvailabilityFilterValue,
  OtcFilterValue,
} from 'infrastructure/hooks/medications';

export type TMedicationsFilterState = {
  page: number;
  search?: string;
  papAvailability: PapAvailabilityFilterValue;
  otc: OtcFilterValue;
  manufacturer?: string;
  sort?: string;
};

const defaultFilter: TMedicationsFilterState = {
  page: 1,
  papAvailability: 'all',
  otc: 'all',
  search: undefined,
  manufacturer: undefined,
  sort: undefined,
};

const papAvailabilityValues: PapAvailabilityFilterValue[] = [
  'all',
  'available',
  'not_available',
];
const otcValues: OtcFilterValue[] = ['all', 'yes', 'no'];

const parseEnumValue = <T extends string>(
  value: string | (string | null)[] | null,
  allowed: readonly T[],
): T | undefined => {
  const parsed = parseSearchStringValue<T>(value);
  if (parsed && allowed.includes(parsed)) {
    return parsed;
  }
  return undefined;
};

const parseFunctions: TParseFunctions<TMedicationsFilterState> = {
  page: parseSearchNumberValue,
  search: parseSearchStringValue,
  manufacturer: parseSearchStringValue,
  papAvailability: (value) =>
    parseEnumValue(value, papAvailabilityValues) ??
    defaultFilter.papAvailability,
  otc: (value) => parseEnumValue(value, otcValues) ?? defaultFilter.otc,
  sort: parseSearchStringValue,
};

export const useMedicationsFilter = () =>
  useQueryFilterNew<TMedicationsFilterState>(defaultFilter, parseFunctions, [
    'page',
    'sort',
  ]);

export type TUseMedicationsFilterReturn = ReturnType<
  typeof useMedicationsFilter
>;
